module.exports = __webpack_public_path__ + "static/media/item7.459738e9.jpg";